import { render } from "./Details.vue?vue&type=template&id=7b3fbeb0"
import script from "./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue?vue&type=script&lang=js"

import "./Details.vue?vue&type=style&index=0&id=7b3fbeb0&lang=css"

import exportComponent from "/opt/buildhome/repo/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__